module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Medium.9c3c7ede.ttf";